import Checkbox from '@components/Checkbox';
import Column from '@components/Column';
import RadioButton from '@components/RadioButton';
import Text from '@components/Text';
import TextField from '@components/TextField';
import styled from '@emotion/styled';
import { useAtomValue } from 'jotai';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { paymentMethodAtom } from '../../atoms/paymentAtoms';

function CashReceipt() {
    const [value, setValue] = useState<string>('none');
    const method = useAtomValue(paymentMethodAtom);
    const { t } = useTranslation('order');
    if (method === 'prepay') {
        return (
            <Container spacing={8}
                fullWidth>
                <Title>
                    <Text size='lg' fontWeight='bold'>{t('cashReceipt.title')}</Text>
                </Title>
                <RadioButton value={value}
                    onChange={setValue}
                    options={[
                        { value: 'none', label: t('cashReceipt.none') },
                        { value: 'private', label: t('cashReceipt.private') },
                        { value: 'business', label: t('cashReceipt.business') },
                    ]}/>
                <TextField placeholder={t('cashReceipt.phonePlaceholder')}/>
                <Checkbox>{t('cashReceipt.saveNumber')}</Checkbox>
            </Container>
        );
    }
    return <Fragment/>;
}

const Container = styled(Column)`
    padding: 0 20px 34px;
`;

const Title = styled.div`
    padding: 8px 0;
`;

export default CashReceipt;
